import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5v14l8 -7l-8 -7","key":"svg-0"}],["path",{"d":"M14 5v14l8 -7l-8 -7","key":"svg-1"}]]

const IconPlayerTrackNext = createReactComponent('outline', 'player-track-next', 'PlayerTrackNext', __iconNode);

export default IconPlayerTrackNext;